import { isNumber } from 'radash';
import { parseColor, resolveColorAlias } from './color.js';

/**
 * Parses a fill color and fill color tone to its CSS value based on the theme.
 *
 * @param theme - The theme object.
 * @param color - The fill color or alias to resolve a value for.
 * @param tone - The level of tone to apply to the fill color.
 */ function parseFillColor(theme, color, tone) {
    return isNumber(tone) ? parseColor(theme, color === 'base' ? 'neutral' : color, tone) : theme.aliases.fillColors[resolveColorAlias(theme, color)][tone];
}

export { parseFillColor };
//# sourceMappingURL=fill-color.js.map
